<template>
  <a :style="logoStyle" :href="url" :target="target"></a>
</template>

<script>
  export default {

      data(){
          let logoConfig = this.$store.state.malMainPageConfig.logo;
          return {
               target:logoConfig.target==null?"_blank":logoConfig.target
          }
      },
      methods:{
        
      },
      computed:{
          logoStyle:function () {
              let logoConfig = this.$store.state.malMainPageConfig.logo;
              return {
                  backgroundImage: 'url(' + logoConfig.imgSrc + ')',
                  backgroundRepeat : 'no-repeat',
                  height : '54px',
                  width : '200px',
                  display : "inline-block"
              }
          },
          url:function(){
              return  this.$store.state.malMainPageConfig.logo.url
          }
      }

  }
</script>

<style scoped lang="scss">

</style>
